module.exports = __webpack_public_path__ + "img/icon-about.3f3a7f13.svg";